import type { OrgMemberListItem } from "../types/orgMembers";

export type InvitationExpiryState = "active" | "expired" | "unknown";

export function getInvitationExpiryState(
    inviteExpiresAt: string | null | undefined,
    now: number = Date.now()
): InvitationExpiryState {
    if (!inviteExpiresAt) return "unknown";
    const expiresAt = Date.parse(inviteExpiresAt);
    if (!Number.isFinite(expiresAt)) return "unknown";
    return expiresAt <= now ? "expired" : "active";
}

export function describeInvitationAccess(
    member: Pick<OrgMemberListItem, "inviteExpiresAt">,
    now: number = Date.now()
): string {
    const { inviteExpiresAt } = member;
    const state = getInvitationExpiryState(inviteExpiresAt, now);
    if (state === "unknown" || !inviteExpiresAt) return "Invitation sent.";

    const date = new Intl.DateTimeFormat("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric"
    }).format(new Date(inviteExpiresAt));

    return state === "expired" ? `Invitation expired ${date}.` : `Invitation expires ${date}.`;
}

export function invitationStatusLabel(
    member: Pick<OrgMemberListItem, "status" | "inviteExpiresAt">,
    now: number = Date.now()
): string {
    return member.status === "Invited" && getInvitationExpiryState(member.inviteExpiresAt, now) === "expired"
        ? "Invitation expired"
        : member.status;
}
